import * as React from "react";
import {
  Button,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { MaterialSymbol } from "@datalake/towercontrol-banner";

// Toolbar export action of the result tables: CSV / JSON of the rows currently shown.
export default function ExportMenu({
  onExport,
  disabled = false,
  formats = ["csv", "json"],
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const close = () => setAnchorEl(null);
  return (
    <>
      <Button
        variant="outlined"
        startIcon={<MaterialSymbol name="download" size="button" />}
        endIcon={<MaterialSymbol name="arrow_drop_down" size="button" />}
        onClick={(e) => setAnchorEl(e.currentTarget)}
        disabled={disabled}
        aria-haspopup="true"
        aria-expanded={Boolean(anchorEl)}
      >
        Export
      </Button>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={close}>
        {formats.map((format) => (
          <MenuItem
            key={format}
            onClick={() => {
              onExport(format);
              close();
            }}
          >
            <ListItemIcon>
              <MaterialSymbol
                name={format === "csv" ? "table_view" : "data_object"}
                size="button"
              />
            </ListItemIcon>
            <ListItemText>Export as {format.toUpperCase()}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
